module.exports = __webpack_public_path__ + "static/img11-531448043bf41aca8245f5291a52685a.jpg";